import { BaseReq, PaginationReq, PaginationResp, UpdaterResp, FileRecord } from "@/core/interface";
import { getCurrentCompanyId, getCurrentUserId } from "@/utils";

export enum TeamTypeEnum {
  BIZ_MAN = 1, // 业务员
  CUSTOMER_MANAGER = 2, // 客户经理
  TENDER_OWNER = 3, // 投标负责人
  DESIGN_OWNER = 4, // 设计负责人
  PROJECT_MANAGER = 5, // 项目经理
}

export enum FlowStatusEnum {
  DTJ = "dtj", // 待提交
  SPZ = "spz", // 审批中
  SPTG = "sptg", // 审批通过
  SPBTG = "spbtg", // 审批不通过
}
export class projectStatusReq extends BaseReq {
  addStatus: Boolean; //	添加还是删除 添加 true 移除false		false
  valCode: string = ""; //	项目状态码		false
  valName: string = ""; //
}

export class ProfileReq extends BaseReq {
  name: string = ""; // 项目名称
  projectTypeId: string | undefined = undefined; // 项目类型
  stage: string | undefined = undefined; // 项目阶段
  provinceId: number | undefined = undefined; // 所在地区 - 省
  cityId: number | undefined = undefined; // 所在地区 - 市
  districtId: number | undefined = undefined; // 所在地区 - 区
  address: string = ""; // 详细地址
  introduction: string = ""; // 项目简介
  remark: string| undefined = undefined; // 备注
  costPrice: number = 0; // 业主目标成本
  contractTotalPrice: number = 0; // 预估合同总价
  signPrice: number = 0; // 预计签约金额
  predictSignDate: string = ""; // 预计签约日期
  predictWorkDate: string = ""; // 预计开工日期
  predictEndDate: string = ""; // 预计完工日期
  bargainRatio: string | undefined = undefined; // 成交概率
  lastCooperationCompanyId: string | undefined = undefined; // 最终用户
  participationWay: number = 1; // 参与方式
  clueSource: string | undefined = undefined; // 线索来源
  fileList: FileRecord[]; //附件
  imgUrl:[]; //现场图片
  customerCooperationCompanyId: string | undefined = undefined; // 客户名称
  customerContacts: string = ""; // 客户联系人
  customerMobile: string = ""; // 联系方式

  bizManId: string | undefined = getCurrentUserId(); // 业务员
  customerManagerId: string | undefined = undefined; // 客户经理
  projectManagerId: string | undefined = undefined; // 项目经理
  tenderOwnerId: string | undefined = undefined; // 投标负责人
  designOwnerId: string | undefined = undefined; // 设计负责人
  userIds:string[]|undefined=getCurrentUserId();
  undertakeCompanyId: string | undefined = getCurrentCompanyId(); // 承接主体
  undertakeCompanyName: string | undefined = undefined; // 承接主体
  projectRegistrantId:string|undefined=getCurrentUserId();// 项目登记人
  realWorkStartDate: string = ""; //实际开工日期
  realWorkEndDate: string = ""; //实际完工日期
  bidEndDate: string = ""; //投标截止时间
  predictDate: string = ""; //预计投标日期
  bidStartDate: string = ""; //开标日期
}

export class ProfilePageReq extends PaginationReq {
  name: string | undefined = undefined; // 项目名称
  cooperationCompanyId: string | undefined = undefined; // 客户ID
  projectTypeId: string | undefined = undefined; // 项目类型
  provinceId: number | undefined = undefined; // 所在地区 - 省
  cityId: number | undefined = undefined; // 所在地区 - 市
  districtId: number | undefined = undefined; // 所在地区 - 区
  salesmanTenantUserId: string | undefined = undefined; // 业务员姓名
  projectStatus: string|undefined = undefined; // 项目状态
  flowStatus: string | undefined = undefined; // 审批状态
  projectName: string | undefined = undefined; // 项目名称
  completionStatus: string | undefined = undefined; // 完成状态
  projectManagerId: string | undefined = undefined; // 项目经理
  undertakeCompanyId: string | undefined = undefined; // 承接主体
  returnProgressStatusFlag: string | undefined = undefined; // 是否需要返回进度状态信息的标识：1-是 null或者0-不是
  progressStatus: string | undefined = undefined; // 进度状态
  overdueStatus: string | undefined = undefined; // 是否超期
  constructor(req = {}) {
    super();
    this.merge(req);
  }
}

export class ProfileListRecord extends UpdaterResp {
  id: number = 0; // 项目ID
  bizNo: string = ""; // 项目编号
  name: string = ""; // 项目名称
  cooperationCompanyId: string = "";
  companyName: string = "";
  projectTypeId: string = "";
  projectTypeName: string = "";
  provinceId: number = 0;
  provinceName: string = "";
  cityId: number = 0;
  cityName: string = "";
  districtId: number = 0;
  districtName: string = "";
  stage: string = "";
  stageName: string = "";
  status: string = "";
  statusName: string = "";
  flowStatus: string = "";
  flowStatusName: string = "";
  salesmanTenantUserId: number = 0;
  salesmanTenantUserName: string = "";
  projectManagerId: string = "";
  projectManagerName: string = "";
  progressStatus: string = "";//"进度状态 1:未启动 2：提前启动 3：正常推进 4：滞后推进 5：超前推进 6：延期中 7：正常完成 8：延期完成 9：超前完成"
  progressStatusName: string = "";
  completionStatus: string = "";
  completionStatusDesc  :string = "";//"工期履约状态描述：提前竣工/按期竣工/超期竣工"
}

export class ProfilePageResp extends PaginationResp<ProfileListRecord> {}

export class ProfileSimpleListReq extends BaseReq {
  otherStatus: string[] = [];
  projectStatus: string | undefined = undefined;
  flowStatus: string | undefined = undefined;
  bizType: string | undefined = undefined;
  addRightBizType: string | undefined = undefined;
  projectStatusList: any = undefined;
}

export class ProfileSimpleRecord {
  id: number = 0;
  name: string = "";
}

export class ProfileSimpleListResp {
  records: ProfileSimpleRecord[] = [];
}

class Team {
  type: TeamTypeEnum;
  tenantUserId: string = "";
  realName: string = "";
}

class Customer {
  cooperationCompanyId: string = "";
  companyName: string = "";
  contacts: string = "";
  mobile: string = "";
}

export class Cooperation {
  id: string = "";
  cooperationCompanyId: string = "";
  companyName: string = "";
  customer: {
    contacts: string;
    cooperationCompanyId: string;
    mobile: string;
  };
}

export class ProfileDetailResp extends UpdaterResp {
  id: string = ""; // 项目ID
  bizNo: string = ""; // 项目编号
  name: string = ""; // 项目名称
  projectTypeId: string = ""; // 项目类型ID
  projectTypeName: string = ""; // 项目类型名称
  stage: string = ""; // 项目阶段Code
  stageName: string = ""; // 项目阶段名称
  status: string = ""; // 项目状态Code
  statusName: string = ""; // 项目状态名称
  provinceId: number = 0; // 所在地区 - 省ID
  provinceName: string = ""; // 所在地区 - 省名称
  cityId: number = 0; // 所在地区 - 市ID
  cityName: string = ""; // 所在地区 - 市名称
  districtId: number = 0; // 所在地区 - 区ID
  districtName: string = ""; // 所在地区 - 区名称
  address: string = ""; // 详细地址
  introduction: string = ""; // 项目简介
  remark: string = ""; // 备注
  customer: Customer = {
    cooperationCompanyId: "", // 客户ID
    companyName: "", // 客户名称
    contacts: "", // 客户联系人
    mobile: "", // 联系方式
  };
  costPrice: number = 0; // 业主目标成本
  contractTotalPrice: number = 0; // 预估合同总价
  signPrice: number = 0; // 预计签约金额
  predictSignDate: string = ""; // 预计签约日期
  predictWorkDate: string = ""; // 预计开工日期
  predictEndDate: string = ""; // 预计完工日期
  bargainRatio: string = ""; // 成交概率
  lastCooperationCompanyId: string = ""; // 最终用户ID
  lastCooperationCompanyName: string = ""; // 最终用户名称
  teams: Team[] = []; // 项目团队
  createBy: ""; // 创建人
  modifiedBy: ""; // 编辑人
  clueSourceName: string = "";
  participationWay: number | undefined = undefined;
  undertakeCompanyId: string | undefined = undefined; // 承接主体
  undertakeCompanyName: string | undefined = undefined; // 承接主体

}

export class ProfileSwitchFlowStatusReq extends BaseReq {
  flowStatus: FlowStatusEnum = FlowStatusEnum.DTJ;
}

export class ThrowSingleApiSubmitReq {
  tenantId: string = "";
  projectId: string = "";
  projectDiscardReason: string = "";
  approvalContent: string = "";
}

export interface ProjectItem {
  bizNo?: string;
  id: string;
  name: string;
  status?: string;
}

export class ProjectViewTopDetailResp  {
  
  // ======================== 资金 ===============================

// ======================== 收入合同 ===============================
incomeContractMoney: string; // 合同金额
totalVisaAmount: string; // 签证金额
contractAndVisaAmount: string; // 合同 + 签证金额
receivablesAmount: string; // 收款金额
receivablesProgress: string; // 收款进度

// ======================== 支出合同 ===============================
outContractMoney: string; // 合同金额
paymentAmount: string; // 付款金额
paymentProgress: string; // 付款进度

// ======================== 成本 ===============================

// ======================== 采购 ===============================

// ======================== 施工 ===============================
planProgress: string; // 计划进度
actualProgress: string; // 实际进度
progressStatus: string; // 进度状态
progressStatusName: string; // 进度状态描述

// ========================  巡检 ===============================
inspectionDclCount: string; // 未整改数量
inspectionYzgCount: string; // 已整改数量
inspectionHgCount: string; // 合格数量

// ========================  质量 ===============================
qualityJcXyCount: string; // 检查的需要整改数量
qualityJcBxyCount: string; // 检查的无需整改数量
qualityZgYzgCount: string; // 整改的整改数量
qualityZgWzgCount: string; // 整改的未整改数量
qualityYsHgCount: string; // 验收的合格数量
qualityYsBhgCount: string; // 验收的不合格数量

// ========================  安全 ===============================
safeJcXyCount: string; // 检查的需要整改数量
safeJcBxyCount: string; // 检查的无需整改数量
safeZgYzgCount: string; // 整改的整改数量
safeZgWzgCount: string; // 整改的未整改数量
safeYsHgCount: string; // 验收的合格数量
safeYsBhgCount: string; // 验收的不合格数量

// ========================  材料 ===============================
warnFlag: boolean; // 是否提醒
warnMsg: string; // 提醒文案
planCount: string; // 预算用量
actualCount: string; // 实际用量
purchaseOrderCount: string; // 采购用量

// ========================  发票 ===============================
jxInvoiceAmount: string; // 进项发票金额
xxInvoiceAmount: string; // 销项发票金额
}